import React from 'react';
import { Card, Typography, Alert } from 'antd';
import { PageLayout } from '../../components/PageLayout/PageLayout';
import TypingAnimation from '../../components/TypingAnimation/TypingAnimation';
import ScreenshotCarousel from '../../components/ScreenshotCarousel/ScreenshotCarousel';
import TesterSignupForm from '../../components/TesterSignupForm/TesterSignupForm';

const { Title, Text } = Typography;

const HomePage = () => {
    return (
        <PageLayout>
            <Card
                variant="outlined"
                style={{
                    textAlign: 'center',
                    border: '2px solid #7a7a7a',
                    // 
                }}
            >
                <Title
                    level={1}
                    style={{
                        // 
                        marginBottom: 30
                    }}
                >
                    Welcome to <Text strong style={{ fontSize: 34, color: '#10b981' }}>BanYano</Text>
                </Title>

                <Alert
                    type="info"
                    description={
                        <span style={{ fontSize: 16, lineHeight: 1.8 }}>
                            The BanYano app is <Text strong style={{ color: '#10b981' }}>coming soon</Text>!
                            Our developer is working hard to bring you an amazing experience and make this
                            project a successful reality.
<br /><br />
                            Thank you for your patience and interest. Stay tuned for updates!
                        </span>
                    }
                    style={{
                        marginBottom: 25,
                        textAlign: 'left'
                    }}
                    showIcon={false}
                />

                {/* Here the screenshots */}
                <Title level={2} style={{ marginBottom: 20 }}>
                    Sneak peek
                </Title>
                <ScreenshotCarousel />
                <Title level={2} style={{ marginTop: 30, marginBottom: 15 }}>
                    Introducing BanYano
                </Title>

                <Alert
                    type="info"
                    description={
                        <div style={{ fontSize: 16, lineHeight: 1.8 }}>
                            <Text>
                                BanYano is named after the <Text strong>Banyan tree</Text>, known for its extensive network of branches and aerial roots that create interconnected structures. Just like the Banyan tree's many branches represent growth and connection, BanYano helps you organize and visualize the connections between your ideas, projects, and information.
                            </Text>
                            <br /><br />
                            <Text strong>Main Features:</Text>
                            <ul style={{ textAlign: 'left', marginTop: 10, paddingLeft: 20 }}>
                                <li><Text strong>Interactive Network Graphs</Text> - Visualize information as interconnected nodes</li>
                                <li><Text strong>Multiple View Modes</Text> - Switch between List, Graph, and Map views</li>
                                <li><Text strong>Hierarchical Organization</Text> - Create parent-child relationships and custom links</li>
                                <li><Text strong>Rich Content Support</Text> - Add text, images, and location data</li>
                            </ul>
                            <br />
                            <Text>
                                Perfect for knowledge management, project planning, research organization, mind mapping, and much more!
                            </Text>
                        </div>
                    }
                    style={{
                        marginBottom: 25,
                        textAlign: 'left'
                    }}
                    showIcon={false}
                />

                <Title level={2} style={{ marginTop: 30, marginBottom: 20 }}>
                    Become an Early Tester
                </Title>

                <TesterSignupForm />

                {/* <Alert
                    type="info"
                    description={
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                            Development in progress
                            <TypingAnimation text="..." speed={300} />
                        </span>
                    }
                    style={{
                        background: 'rgba(255, 255, 255, 0.05)',
                        fontSize: '0.95rem'
                    }}
                    showIcon={false}
                /> */}
            </Card>
        </PageLayout>
    );
}

export default HomePage;